<template>
    <div>
        <el-dialog title="" top="1vh" :show-close="false" :visible.sync="verinscribir"
            :fullscreen="$isMobile() ? true : false" :width="$isMobile() ? '100%' : '500px'"
            :close-on-press-escape="false" :close-on-click-modal="false" class="no-padding-dialog">
            <div>
                <div class="footer-msg" v-if="vista === 'login'"><strong>IMPORTANTE: </strong> al presionar el botón
                    <strong>REALIZAR
                        {{ tienePre }}</strong>, acepta estar informado sobre los
                    <a href="/deberes-y-derechos-fdci" style="text-decoration:underline" target="_blank"
                        rel="noopener noreferrer"><strong> DEBERES Y
                            DERECHOS DEL SISTEMA
                            DE
                            FORMACIÓN DOCENTE CONTINUA E INVESTIGACIÓN DE TUCUMÁN.
                        </strong></a>
                    <br>
                    <p v-if="comision.tienePre">
                        La PRE-INSCRIPCIÓN a una capacitación NO GARANTIZA su participación en la misma si su
                        situación es irregular respecto a los requisitos mencionados.
                    </p>
                </div>
            </div>

            <h2 class="ins-h2">
                <span>Nueva {{ tienePre }}</span>
                <small>
                    {{ comision.nombreCapa }}</small>
                Comisión #{{ comision.id }}

                <!-- <small>Inicia {{ comision.fecha_inicio | moment('LL') }}</small> -->
            </h2>
            <div style="max-width:350px; margin:0 auto; padding:20px; font-size:18px; word-break:break-word"
                v-if="vista == 'error'">
                <strong>{{ tienePre }} FALLIDA</strong>
                <br>
                La {{ tienePre }} no pudo realizarse
                <br>
                <strong>MOTIVO:</strong>
                {{ motivo || 'CUPO COMPLETO' }}

                <el-button type="danger" class="btn-100 btn-fondo" :loading="cargando"
                    @click="cerrarModal">REGRESAR</el-button>
            </div>

            <div style="max-width:350px; margin:0 auto; padding:20px; font-size:18px; word-break:break-word"
                v-if="vista == 'ok'">
                <strong>{{ tienePre }} CORRECTA</strong>
                <br>
                Su {{ tienePre }} se realizó correctamenete
                <br>
                <strong>Código de {{ tienePre }}:</strong>
                <h2>{{ motivo }}</h2>

                <el-button type="success" class="btn-100 btn-fondo1" :loading="cargando" @click="verListado">VER MI
                    PREINSCRIPCIÓN</el-button>
            </div>
            <div style="padding:20px">
                <el-form :model="form" style="max-width:350px; margin:0 auto;" ref="form" :label-position="'top'"
                    v-if="vista == 'login'" class="login" label-width="80px" :inline="false" size="normal">
                    <br>
                    <p style="font-size:16px; border-bottom:1px solid #f1f1f1; padding-bottom:3px">Ingrese sus datos
                        para
                        validar su identidad</p>
                    <br>
                    <el-form-item label="Cuil (sin guiones)" prop="cuil" :rules="[
            {
                required: true,
                message: 'campo obligatorio',
                trigger: 'blur',
            },
        ]">
                        <el-input v-mask="'############'" v-model="form.cuil"></el-input>
                    </el-form-item>
                    <el-form-item label="Contraseña" prop="pass" :rules="[
            {
                required: true,
                message: 'campo obligatorio',
                trigger: 'blur',
            },
        ]">
                        <el-input show-password v-model="form.pass"></el-input>
                    </el-form-item>
                    <el-form-item>

                        <div class="acuerdo">
                            <p class="text-acuerdo">
                                Al momento de completar la preinscripción, acepto que mi nombre, apellido, últimos 4
                                dígitos del CUIL y el estado de mi preinscripción sea publicado en la presente web
                            </p>


                            <el-radio-group v-model="form.confirmaDatos" size="mini">
                                <el-radio-button :label="1">
                                    Estoy de acuerdo
                                </el-radio-button>
                                <!-- <el-radio-button :label="0">
                                    No mostrar mis datos
                                </el-radio-button> -->
                            </el-radio-group>

                        </div>

                        <el-button type="azul" class="btn-100 upper" style="margin-top: 0;"
                            :disabled="form.confirmaDatos == 1 ? false : true" :loading="cargando"
                            @click="enviarInscripcion('form')">REALIZAR
                            {{ tienePre }}</el-button>
                        <el-button type="danger" :disabled="cargando ? true : false" class="btn-100"
                            @click="cerrarModal">
                            CANCELAR</el-button>







                    </el-form-item>

                </el-form>
            </div>

        </el-dialog>

    </div>
</template>

<script>
import {EventBus} from "@/event-bus"
import { HTTP } from '@/axios'

    export default {
        data() {
            return {
                verinscribir: false,
                comision: {},
                form:{},
                motivo:'',
                cargando:false,
                vista:'login',
                tienePre: 'inscripción',
                metodo:'inscribir'
            }
        },
        created()
        {
            EventBus.$on('verinscribir', (p) => {
                this.verinscribir = true
                this.comision = p
                this.tienePre = p.tienePre ? 'Preinscripción' : 'Inscripción'
                this.metodo = p.tienePre ? 'preinscribir' : 'inscribir'
                console.log('verinscribir', (p));
            })
        },
        methods: {
            cerrarModal()
            {
             
            //  EventBus.$emit('recargarCapa', (1))
             this.verinscribir = false
             this.form = {}
                this.vista = 'login'
            },
            verListado()
            {
              
                // console.log({ ...this.$route.params, com: this.comision.id });
                    this.$router.push({
                        name: 'detalleCom',
                        params: { ...this.$route.params, com: this.comision.id }, // Mantén los otros parámetros y cambia solo `id`

                    });
                
            },
            enviarInscripcion(formName) {
                const baseURL = window.location.hostname === 'localhost' || window.location.hostname === 'paginatest.tucuman.edu.ar'
                    ? '/capaTest/'
                    : '/capa/';
                this.$refs[formName].validate((valid) => {
                    if (valid) {
                        this.form.comision = this.comision.id
                        this.form.capa = this.comision.capacitacion_id
                       
                        this.cargando = true
                        setTimeout(() => {
                            HTTP.post(baseURL + this.metodo, this.form)
                                .then(res => {
                                   
                                    if(res.data)
                                    {
                                        if (res.data.ins && res.data.ins.inscripcion != -1 )
                                        {

                                            EventBus.$emit('actualizarComision', res.data.ins)
                                        }
                                        console.log(res.data.ins);
                                        if (res.data.codigo) {
                                            this.motivo = res.data.codigo
                                            this.vista= 'ok'
                                        }
                                        else {
                                            this.motivo = res.data.motivo
                                            this.vista = 'error'
                                        }
                                    }
                                    else{
                                        this.vista = 'error'
                                    }
                                    
                                    this.cargando = false
                                })
                                .catch((e) => {
                                    this.cargando = false
                                    this.vista = 'error'
                                    console.log(e);
                                })
                        }, 100);
                    }
                else{
                 return false;
                }
            })
                
              
               
            }
        },
    }
</script>
<style>
.no-padding-dialog .el-dialog__header {
    display: none;
}
.no-padding-dialog .el-dialog__body {
    padding: 0 !important;
}
</style>
<style lang="scss" scoped>
.acuerdo{
        padding: 10px;
            background: #F9FBE7;
            color: #000000;
}
.text-acuerdo{
        line-height: 1.2;
            word-break: break-word;
}
.footer-msg{
    line-height: 1.2;
        color: rgb(0 0 0);
        word-break: break-word;
        padding: 20px 20px;
        background: #FFEBEE;
}
.ins-h2{
    text-align: center;
    background: #f1f1f1;
    padding: 10px;
    margin-bottom: 10px;
    color: #000;
}
.ins-h2 small{
display: block;
font-size: 12px;
word-break: break-word;
margin-bottom: 10px;
}
.ins-h2 span {
    display: block;
    font-size: 14px;
    word-break: break-word;
    
}
.aceptar {
   
    font-family: 'Roboto', sans-serif;
    background: #174263 url(@/assets/base2.png) !important;
    /* Cambio clave: Ancho completo para el botón */
}
.btn-fondo1{
    font-family: 'Roboto', sans-serif;
        background: #0a8138 url(@/assets/base2.png) !important;
        border-color: #0a8138;
}

.el-button--danger {
    text-transform: uppercase;
    background: #800322ce url(@/assets/base2.png) !important;
    border-color: #800322ce !important;
}
</style>